import React, {useEffect} from "react";
import AuthSection from "../../components/AuthSection";
import { useRouter } from "next/router";
import {useAuth} from '../../util/auth';
import {fetchMeta} from '../../util/pages';
import {withUserGetServerSideProps} from '../../util/util';
import wrapper from '../../store/store';
import SeoTags from '../../components/SeoTags';

const seoConfigByType = {
  signin: {
    title: 'Login',
    description: 'Create yourself an account and enjoy 14-days free trial.'
  },
  signup: {
    title: 'Try Casehub',
    description: 'Create yourself an account and enjoy 14-days free trial.'
  },
  def: {
    title: 'Casehub'
  }
}

function AuthPage(props) {
  const router = useRouter();
  const auth = useAuth();

  useEffect(() => {
    if (router.query.type === 'signout') {
      auth.signout();
      router.push('/');
    } else {
      if(auth.isAuthenticated && !router.query.next) {
        router.push('/user/dashboard');
      }
    }
  }, [router, auth]);

  return (
    <>
      <SeoTags config={seoConfigByType[router.query.type] || seoConfigByType.def} />
      <AuthSection
          color="white"
          size="large"
          backgroundImage=""
          backgroundImageOpacity={1}
          buttonColor="primary"
          buttonInverted={false}
          type={router.query.type}
          afterAuthPath={router.query.next ? decodeURIComponent(router.query.next) : '/user/dashboard'}
      />
    </>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async (ctx) => {
  const content = await fetchMeta();
  return {
    props: {content}
  }
}));

export default AuthPage;
